import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Images
import agripac from "assets/images/aensa/agripac.png";
import altvet from "assets/images/aensa/ALTVET.png";
import cclabs from "assets/images/aensa/cclabs.jpg";
import ecuaquimica from "assets/images/aensa/ecuaquimica.jpg";
import farcovet from "assets/images/aensa/farcovet.png";
import farmagro from "assets/images/aensa/farmagro.png";
import grandes from "assets/images/aensa/grandes.png";
import impvet from "assets/images/aensa/impvet.png";
import imvab from "assets/images/aensa/imvab.png";
import james from "assets/images/aensa/james.png";
import lavetec from "assets/images/aensa/lavetec.png";
import life from "assets/images/aensa/life.png";
import montana from "assets/images/aensa/montana.png";
import nutrisal from "assets/images/aensa/nutrisal.png";
import pronac from "assets/images/aensa/pronac.png";
import qsi from "assets/images/aensa/QSI.png";
import tadec from "assets/images/aensa/tadec.jpg";
import zoetis from "assets/images/aensa/zoetis.png";

const partnersInfo = [
  { image: agripac, alt: "Agripac" },
  { image: altvet, alt: "altvet" },
  { image: cclabs, alt: "cclabs" },
  { image: farcovet, alt: "farcovet" },
  { image: farmagro, alt: "farmagro" },
  { image: grandes, alt: "grandes" },
  { image: impvet, alt: "impvet" },
  { image: imvab, alt: "imvab" },
  { image: james, alt: "james" },
  { image: lavetec, alt: "lavetec" },
  { image: life, alt: "life" },
  { image: montana, alt: "montana" },
  { image: nutrisal, alt: "nutrisal" },
  { image: pronac, alt: "pronac" },
  { image: qsi, alt: "qsi" },
  { image: tadec, alt: "tadec" },
  { image: zoetis, alt: "zoetis" },
  { image: ecuaquimica, alt: "ecuaquimica" },
];

// Anaytics dashboard components

function PartnersLogo() {
  const half = Number(partnersInfo.length / 2);

  return (
    <div>
      <br />
      <hr width="90%" align="center" />
      <br />
      <MDTypography variant="h6">Nuestros Partners</MDTypography>
      <br />
      <Grid item xs={12} sm={8} lg={10}>
        <Stack direction="row" spacing={3}>
          {partnersInfo.slice(0, half).map((p, index) => (
            <MDBox
              key={index}
              component="img"
              id={index}
              src={p.image}
              alt={p.alt}
              borderRadius="lg"
              shadow="md"
              width="8%"
              height="8%"
            />
          ))}
        </Stack>
        <Stack direction="row" spacing={3}>
          {partnersInfo.slice(half).map((p, index) => (
            <MDBox
              key={index}
              component="img"
              id={index}
              src={p.image}
              alt={p.alt}
              borderRadius="lg"
              shadow="md"
              width="8%"
              height="8%"
            />
          ))}
        </Stack>
      </Grid>
    </div>
  );
}

export default PartnersLogo;
